import { action } from 'app/actions';

export const GET_EVALUATIONS = 'simulated/GET_EVALUATIONS';
export const getEvaluations = payload => action(GET_EVALUATIONS, { payload });

export const GET_EVALUATION_INFORMATION = 'simulated/GET_EVALUATION_INFORMATION';
export const getEvaluationInformation = payload => action(GET_EVALUATION_INFORMATION, { payload });

export const GET_EVALUATION_STEPS = 'simulated/GET_EVALUATION_STEPS';
export const getEvaluationSteps = payload => action(GET_EVALUATION_STEPS, { payload });

export const REMOVE_CONTENTMAP_ABILITIES = 'simulated/REMOVE_CONTENTMAP_ABILITIES';
export const removeContentmapAbilities = payload =>
  action(REMOVE_CONTENTMAP_ABILITIES, { payload });

export const CHANGE_TEACHER_EDIT = 'simulated/CHANGE_TEACHER_EDIT';
export const changeTeacherEdit = payload => action(CHANGE_TEACHER_EDIT, { payload });

export const GET_GROUPS = 'simulated/GET_GROUPS';
export const getGroups = payload => action(GET_GROUPS, { payload });
